export default __webpack_public_path__ + "static/media/fedex.6bfb70a1.jpg";